import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {catchError, map, of} from 'rxjs';
import {SettingsMenuItemType} from '../types/generated/settingsMenuItemType';
import {NavService} from '../services/nav.service';
import {RouterService} from '../services/router.service';
import {TokenService} from '../services/token.service';

export const routeMenuAccessGuard: CanActivateFn = (route) => {
  const navService = inject(NavService);
  const routerService = inject(RouterService);
  const tokenService = inject(TokenService);
  const requiredMenuType = route.data?.['requiredMenuType'] as SettingsMenuItemType | undefined;

  if(!requiredMenuType || !tokenService.hasToken()) {
    return true;
  }

  return navService.hasUserMenuAccess(requiredMenuType)
  .pipe(
    map((hasAccess) => {
      if(!hasAccess) {
        routerService.navigateTo('/home');
      }
      return hasAccess;
    }),
    catchError(() => {
      routerService.navigateTo('/home');
      return of(false);
    })
  );
};
